<template>
  <el-tag :type="tagType">{{ description }}</el-tag>
</template>

<script>
import { RAF_STATE, RAF_DESCRIPTION_MAP } from '@/enum/RAFStatuses';

// maps a state to a tag type
const TYPE_MAP = {};
TYPE_MAP[RAF_STATE.PENDING] = '';
TYPE_MAP[RAF_STATE.DOES_NOT_QUALIFY] = 'danger';
TYPE_MAP[RAF_STATE.DNQ_PRIOR_YEAR_CLIENT] = 'danger';
TYPE_MAP[RAF_STATE.APPROVED] = 'success';
TYPE_MAP[RAF_STATE.PAID] = 'info';

export default {
  props: {
    rafStatus: {
      type: Number,
      default: 0,
    },
    isPaid: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tagType() {
      if (this.isPaid) {
        return TYPE_MAP[RAF_STATE.PAID];
      }
      return TYPE_MAP[this.rafStatus];
    },
    description() {
      if (this.isPaid) {
        return RAF_DESCRIPTION_MAP[RAF_STATE.PAID];
      }
      return RAF_DESCRIPTION_MAP[this.rafStatus];
    },
  },
};

</script>
